import React, { useState } from "react";
import ComponentHeader from "../Header/ComponentHeader";
import styled from "styled-components";
import KeyFigureNew from "../Elements/KeyFigureNew";
import BubbleFlexSvg from "../Elements/BubbleFlexSvg";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import { createMarkup } from "../../Helpers/CommonHelper";
import {
  headingSmall,
  Heading2,
  Heading6,
  HeadingMunicipality,
  Line,
  FiguresWrapper
} from "../../Util/StyleProps";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { useInView } from "react-intersection-observer";
import {
  Sign,
  ArrowValue,
  numberWithSpaces,
  isCurrentYear
} from "../../Helpers/CommonHelper";
import HighLineChartLine from "../Charts/HighChartLineChart";
import EmptySpace from "../Elements/EmptySpace";
import FigureBoxPopulation from "./FigureBoxPopulation";
import PopulationChange from "./PopulationChange";

const PopulationContainer = props => {
  const { sweden, data, populationchangedata, blockColor, scroll } = props;
  var xaxissize = "";
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: true
  });

  const Wrapper = styled.div`
      background: #FFFFFF;
      border-radius: 16px;
      padding: 24px 24px 0;

  `;

  let year = populationchangedata[0] ? populationchangedata[0].year : "";
  const lastYearPop = sweden.population.values.slice(-1);
  const lastYear = sweden.population.years.slice(-1);
  const beforeYearPop = sweden.population.values.slice(-2)[0];
  const popDiff = lastYearPop - beforeYearPop;

  let popKingdom = null;

  let municipality1 = data[0];
  let municipality2 = data[1];

  let municipality1Change = populationchangedata[0];
  let municipality2Change = populationchangedata[1];

  const noWrapPopulation =
    "<span class='text-nowrap'>" + numberWithSpaces(lastYearPop) + "</span>";

  const noWrapDiff =
    "<span class='text-nowrap'>" + numberWithSpaces(popDiff) + "</span>";

  let subText = `I slutet av ${
    lastYear ? lastYear : "(årtal saknas)"
  } var Sveriges folkmängd ${
    lastYearPop ? noWrapPopulation : "(befolkningsmängd ej tillgänglig)"
  } personer.`;

  var subTextKeyFig = "personer";

  // Accessibility
  const ariaLabel = (municipality, year) => {
    return municipality
      ? `I slutet av ${year} var befolkningen i ${
          municipality.name
        } kommun ${municipality.values.slice(-1).pop()} personer`
      : "";
  };

  const ariaLabelPopChange = municipalityChange => {
    return municipalityChange
      ? `Befolkningen i ${municipalityChange.name} kommun ${
          Math.sign(municipalityChange.value) === 0
            ? isCurrentYear(municipalityChange.year)
              ? "är"
              : "var"
            : Math.sign(municipalityChange.value) > 0
            ? "ökade med"
            : "minskade med"
        } ${Math.abs(municipalityChange.value)} personer (år ${
          municipalityChange.year
        })`
      : "";
  };

  return (
    <React.Fragment>
      <BlockLayout background={blockColor}>
        <svg style={{ marginBottom: "32px" }} xmlns="http://www.w3.org/2000/svg" width="69" height="65" viewBox="0 0 69 65" fill="none">
            <path d="M53.2117 11.4617C51.6172 11.4617 50.2625 10.9061 49.1475 9.795C48.0319 8.68389 47.4742 7.33139 47.4742 5.7375C47.4742 4.14306 48.0297 2.78833 49.1408 1.67333C50.2519 0.557779 51.6044 0 53.1983 0C54.7928 0 56.1475 0.555556 57.2625 1.66667C58.3781 2.77722 58.9358 4.12972 58.9358 5.72417C58.9358 7.31806 58.3803 8.67278 57.2692 9.78834C56.1581 10.9039 54.8056 11.4617 53.2117 11.4617ZM48.205 64.705V37.4425C48.205 35.7675 47.8097 34.26 47.0192 32.92C46.2286 31.58 45.0169 30.5725 43.3842 29.8975L46.9617 19.9933C47.4061 18.69 48.2042 17.6431 49.3558 16.8525C50.5075 16.0619 51.7906 15.6667 53.205 15.6667C54.6194 15.6667 55.9025 16.0567 57.0542 16.8367C58.2058 17.6167 59.0039 18.6689 59.4483 19.9933L68.205 43.9033H59.0067V64.705H48.205ZM11.545 11.4617C9.95056 11.4617 8.59583 10.9061 7.48083 9.795C6.36528 8.68389 5.8075 7.33139 5.8075 5.7375C5.8075 4.14306 6.36306 2.78833 7.47417 1.67333C8.58528 0.557779 9.93778 0 11.5317 0C13.1261 0 14.4808 0.555556 15.5958 1.66667C16.7114 2.77722 17.2692 4.12972 17.2692 5.72417C17.2692 7.31806 16.7136 8.67278 15.6025 9.78834C14.4914 10.9039 13.1389 11.4617 11.545 11.4617ZM5.865 64.705V41.4675H0V21.0508C0 19.7453 0.474722 18.6178 1.42417 17.6683C2.37417 16.7183 3.50194 16.2433 4.8075 16.2433H18.2692C19.5747 16.2433 20.7025 16.7183 21.6525 17.6683C22.6019 18.6178 23.0767 19.7453 23.0767 21.0508V41.4675H17.2117V64.705H5.865Z" fill="#1F44FF"/>
            <path d="M34.5791 30.41C33.2569 30.41 32.1471 29.9547 31.2499 29.0442C30.3527 28.1336 29.9041 27.0278 29.9041 25.7267C29.9041 24.4261 30.3538 23.3216 31.2533 22.4133C32.1533 21.505 33.2644 21.0508 34.5866 21.0508C35.8877 21.0508 36.9924 21.5064 37.9008 22.4175C38.8085 23.328 39.2624 24.4336 39.2624 25.7341C39.2624 27.0353 38.8071 28.14 37.8966 29.0483C36.986 29.9561 35.8802 30.41 34.5791 30.41ZM30.3208 64.705V51.5958H26.3783V37.4425C26.3783 36.4503 26.7252 35.6072 27.4191 34.9133C28.1135 34.2189 28.9566 33.8717 29.9483 33.8717H39.1858C40.1774 33.8717 41.0205 34.2189 41.7149 34.9133C42.4088 35.6072 42.7558 36.4503 42.7558 37.4425V51.5958H38.8141V64.705H30.3208Z" fill="#0F0865"/>
        </svg>
        <ComponentHeader heading={"Så många är vi"} text={subText} />
        {municipality1 ? (
          <>
            <FigureBoxPopulation
              municipality1={municipality1}
              municipality2={municipality2}
              year={year}
              scroll={scroll}
            />
            <div ref={ref}>
              {municipality1 ? (
                <SvgLayout
                 paddingBottom="56px"
                  ariaLabel={`Det här linjediagramet visar populationsförändring i ${
                    municipality1.name
                  } kommun ${
                    municipality2 ? "och " + municipality2.name + "kommun" : ""
                  } `}
                  useTabIndex
                >
                  <Wrapper>
                    <HighLineChartLine
                      data={data}
                      startpoint={1970}
                      triggerAnimation={inView}
                    />
                  </Wrapper>
                </SvgLayout>
              ) : (
                ""
              )}
            </div>
            <PopulationChange
              sweden={sweden}
              data={data}
              populationchangedata={populationchangedata}
            />
          </>
        ) : null}
      </BlockLayout>
    </React.Fragment>
  );
};

PopulationContainer.defaultProps = {
  data: [],
  sweden: [],
  populationchangedata: []
};

export default PopulationContainer;
